import { render, staticRenderFns } from "./locked_overlay.vue?vue&type=template&id=c7a7b3ec&scoped=true&lang=pug"
import script from "./locked_overlay.vue?vue&type=script&lang=js"
export * from "./locked_overlay.vue?vue&type=script&lang=js"
import style0 from "./locked_overlay.vue?vue&type=style&index=0&id=c7a7b3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a7b3ec",
  null
  
)

export default component.exports